---
title: FishIQ Guide
description: How FishIQ uses signals, patterns, and guidance without promising certainty or guaranteed catches.
---

# FishIQ Guide

FishIQ is Roddo's fishing intelligence layer. It is designed to surface helpful signals and guidance, not certainty.

## What FishIQ can help with

- Thinking about likely species in an area.
- Comparing habitat and seasonal context.
- Reading patterns from conditions and observations.
- Turning past logs into better trip planning.

## What FishIQ does not do

FishIQ does not guarantee catches. It does not replace local rules, emergency services, navigation tools, or your judgment.

## Best way to use it

Treat FishIQ like a calm second opinion. Check the signal, compare it with what you see outside, then make the safest and most responsible choice.

---

### Keep learning

- [Fishing map guide](/learn/fishing-map)
- [Catch log guide](/learn/catch-log)
- [Fishing safety reminders](/learn/fishing-safety)
